import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Save a deep link to redirect to after sign in.
 *
 * If the user isn't authenticated, we check for a path to set as the deepLink.
 * We skip saving the deepLink if the user navigates to "/signIn".
 * Additionally, since we redirect to "/personal-dashboard" when a user logs in or navigates to "/",
 * these paths don't need to be saved as a deepLink.
 *
 * Writes are skipped while auth is still resolving so we don't treat a logged-in user's initial
 * page load as an unauthenticated visit (AppShell starts with isAuthenticated=false until currentUser() returns).
 */
export function useDeepLink(isAuthenticated: boolean, isAuthenticating: boolean) {
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticating) return;

    const deepLink = localStorage.getItem("deepLink");
    const skipDeepLink = ["/signIn", "/", "/personal-dashboard"].includes(location.pathname);
    if (!isAuthenticated && !skipDeepLink && !deepLink) {
      const currentPath = location.pathname + location.search;
      localStorage.setItem("deepLink", currentPath);
    }
  }, [isAuthenticated, isAuthenticating, location]);
}
